import { PointValue } from "../models/inspections/Inspections";

/**
 * What the Complete button demands of the technician.
 *
 * AB#913492. Keyed off FailedFlag, which is the point's verdict - never off
 * OutOfToleranceFlag, which only says a reading sits outside its band. A full
 * range point whose as-received reading is out of tolerance but whose repair
 * pass brought it back passes, and must not be counted here: counting it forces
 * the technician to declare the whole inspection failed and write a failure
 * comment before they can finish, which is the defect this fixes.
 *
 * Deliberately free of runtime imports so it can be tested on its own.
 */

/** The points that fail the inspection, each listed once. */
export const getFailedPointIds = (pointValues: PointValue[]): number[] => {
  const seen: Record<string, true> = {};
  const failed: number[] = [];

  for (const pv of pointValues) {
    if (!pv.FailedFlag) continue;
    const key = String(pv.PointId);
    if (seen[key]) continue;
    seen[key] = true;
    failed.push(pv.PointId);
  }

  return failed;
};

/** Whether a failure declaration is demanded at all. */
export const hasFailedPoints = (pointValues: PointValue[]): boolean =>
  getFailedPointIds(pointValues).length > 0;

/** Whether any failing point is still missing its comment. */
export const hasFailedPointsWithoutComment = (
  pointValues: PointValue[],
  getCommentForPoint: (pointId: number) => string
): boolean =>
  getFailedPointIds(pointValues).some((pointId) => !getCommentForPoint(pointId));
